<template>
  <v-container class="card vld-parent">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-row v-if="mostrarParametros">
      <v-col class="pb-2" cols="12" md="12">
        <v-select
          @change="onTipoAhorroChange"
          prepend-inner-icon="mdi-piggy-bank"
          v-if="parametrosCoacAhorros"
          :items="parametrosCoacAhorros.ahorros"
          :error-messages="tipoAhorroError"
          item-text="descripcion"
          item-value="id"
          v-model="calculadora.tipoAhorro"
          label="Tipo de Ahorro"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="mostrarParametros && calculadoraValidar.tasaInteres">
      <v-col class="pb-2" cols="12" md="12">
        <v-text-field
          readonly
          type="number"
          v-if="parametrosCoacAhorros"
          prepend-inner-icon="mdi-sack-percent"
          label="Tasa de Interes"
          v-model="interes"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row
      v-if="mostrarParametros && calculadoraValidar.montoInicial && !calculadoraValidar.diasPlazo"
    >
      <v-col class="pb-2" cols="12" md="12">
        <v-text-field
          type="number"
          v-if="parametrosCoacAhorros"
          prepend-inner-icon="mdi-cash-100"
          label="Monto Inicial"
          v-model="$v.calculadora.montoInicial.$model"
          required
          :error-messages="montoInicialError"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="mostrarParametros && calculadoraValidar.diasPlazo">
      <v-col class="pb-2" cols="12" md="12">
        <v-text-field
          type="number"
          v-if="parametrosCoacAhorros"
          prepend-inner-icon="mdi-cash-100"
          label="Capital"
          v-model="$v.calculadora.montoInicial.$model"
          required
          :error-messages="montoInicialError"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="mostrarParametros && calculadoraValidar.mesesPlazo">
      <v-col class="pb-2" cols="12" md="12">
        <v-text-field
          type="number"
          prepend-inner-icon="mdi-calendar"
          label="Plazo en Meses"
          v-model="$v.calculadora.mesesPlazo.$model"
          required
          :error-messages="mesesPlazoError"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="mostrarParametros && calculadoraValidar.diasPlazo">
      <v-col class="pb-2" cols="12" md="12">
        <v-text-field
          type="number"
          prepend-inner-icon="mdi-calendar"
          label="Plazo en Días"
          v-model="$v.calculadora.diasPlazo.$model"
          required
          :error-messages="diasPlazoError"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="mostrarParametros && calculadoraValidar.cuotaMensual">
      <v-col class="pb-2" cols="12" md="12">
        <v-text-field
          type="number"
          prepend-inner-icon="mdi-cash-multiple"
          label="Cuota Mensual"
          v-model="$v.calculadora.cuotaMensual.$model"
          required
          :error-messages="cuotaMensualError"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="mostrarCalcularAhorro">
      <v-col class="pt-0">
        <v-btn
          v-if="parametrosCoacAhorros"
          block
          depressed
          dense
          :color="parametrosCoacAhorros.colorSecundario"
          dark
          @click="onCalcularAhorroClick"
        >
          <v-icon right dark> mdi-calculator </v-icon>&nbsp; CALCULAR AHORRO</v-btn
        >
      </v-col>
    </v-row>
    <span id="printMe">
      <v-row v-if="ahorroCalculado">
        <v-col class="col-md-12 col-sm-12">
          <v-card class="mx-auto" outlined>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Fecha de Simulación"></Tooltip>
                        FECHA DE SIMULACION
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.fecha }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Plazo"></Tooltip>
                        PLAZO
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.plazo }}
                      </td>
                    </tr>

                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Capital"></Tooltip>
                        CAPITAL
                      </td>
                      <td class="text-left">
                        {{ calculadora.montoInicial }}
                      </td>
                    </tr>
                    <tr v-if="ahorroCalculado.tasaInteres">
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Tasa de interes"></Tooltip>
                        TASA DE INTERÉS
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.tasaInteres }}
                      </td>
                    </tr>
                    <tr v-if="ahorroCalculado.tasaEfectivaAnual">
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Fecha de Simulación"></Tooltip>
                        TAZA EFECTIVA ANUAL INTERÉS
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.tasaEfectivaAnual }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Fecha de Simulación"></Tooltip>
                        INTERÉS GANADO
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.interesGanado }}
                      </td>
                    </tr>
                    <tr v-if="ahorroCalculado.ahorroTotal">
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Ahorro Total"></Tooltip>
                        AHORRO TOTAL
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.ahorroTotal }}
                      </td>
                    </tr>
                    <tr v-if="ahorroCalculado.retencion">
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Valor retenido"></Tooltip>
                        RETENCION
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.retencion }}
                      </td>
                    </tr>
                    <tr v-if="ahorroCalculado.montoARecibir">
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Monto a recibir"></Tooltip>
                        MONTO A RECIBIR
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.montoARecibir }}
                      </td>
                    </tr>
                    <tr v-if="ahorroCalculado.totalARecibir">
                      <td class="text-left font-weight-medium">
                        <Tooltip texto="Total a recibir"></Tooltip>
                        TOTAL A RECIBIR
                      </td>
                      <td class="text-left">
                        {{ ahorroCalculado.totalARecibir }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="ahorroCalculado">
        <v-col v-if="ahorroCalculado.ahorroCalculo">
          <v-row>
            <v-col class="text-h4">TABLA DE AMORTIZACIÓN</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">PERIODO</th>
                      <th class="text-left">FECHA</th>
                      <th class="text-left">INTERÉS</th>
                      <th class="text-left">CUOTA</th>
                      <th class="text-left">SALDO FINAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="cuota in ahorroCalculado.ahorroCalculo" :key="cuota.numPago">
                      <td>{{ cuota.periodo }}</td>
                      <td>{{ cuota.fecha }}</td>
                      <td>{{ cuota.interes }}</td>
                      <td>{{ cuota.cuota }}</td>
                      <td>{{ cuota.saldoFinal }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </span>
    <v-row v-if="ahorroCalculado">
      <v-col class="pt-2">
        <v-btn
          v-if="parametrosCoacAhorros"
          block
          depressed
          dense
          :color="parametrosCoacAhorros.colorSecundario"
          dark
          @click="onImprimirClick"
        >
          <v-icon right dark> mdi-printer </v-icon>&nbsp; IMPRIMIR</v-btn
        >
      </v-col>
      <v-col class="pt-2">
        <v-btn
          v-if="parametrosCoacAhorros"
          block
          depressed
          dense
          color="grey"
          @click="onCalcularNuevamenteClick"
        >
          <v-icon right dark> mdi-calculator </v-icon>&nbsp; CALCULAR NUEVAMENTE</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, requiredIf, decimal, numeric } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import Tooltip from "./Tooltip";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Parametros",
  components: { Tooltip, Loading },
  data: () => ({
    ahorroSelecionado: null,
    calculadora: {
      montoInicial: null,
      mesesPlazo: null,
      diasPlazo: null,
      cuotaMensual: null,
    },
    calculadoraValidar: {
      montoInicial: false,
      mesesPlazo: false,
      diasPlazo: false,
      cuotaMensual: false,
      tasaInteres: false, //La uso solo par ocultar y mostrat interes, no hay validacion
    },
    fullPage: true,
    mostrarParametros: true,
    mostrarCalcularAhorro: false,
  }),
  methods: {
    onTipoAhorroChange() {
      this.mostrarCalcularAhorro = true;
      this.resetParametros();
      this.ahorroSelecionado = this.parametrosCoacAhorros.ahorros.find(
        (a) => a.id == this.calculadora.tipoAhorro
      );
      if (this.ahorroSelecionado) {
        this.calculadoraValidar.tasaInteres = true;
        this.calculadoraValidar.montoInicial = this.ahorroSelecionado.camposAhorro[0].montoInicial;
        this.calculadoraValidar.mesesPlazo = this.ahorroSelecionado.camposAhorro[0].mesesPlazo;
        this.calculadoraValidar.diasPlazo = this.ahorroSelecionado.camposAhorro[0].diasPlazo;
        this.calculadoraValidar.cuotaMensual = this.ahorroSelecionado.camposAhorro[0].cuotaMensual;
      }
    },
    resetParametros() {
      this.calculadora.montoInicial = null;
      this.calculadora.mesesPlazo = null;
      this.calculadora.diasPlazo = null;
      this.calculadora.cuotaMensual = null;

      this.calculadoraValidar.montoInicial = false;
      this.calculadoraValidar.mesesPlazo = false;
      this.calculadoraValidar.diasPlazo = false;
      this.calculadoraValidar.cuotaMensual = false;
      this.calculadoraValidar.tasaInteres = false;

      this.calculadora.montoInicial = null;
      this.calculadora.mesesPlazo = null;
      this.calculadora.diasPlazo = null;
      this.calculadora.cuotaMensual = null;
    },
    onCalcularAhorroClick() {
      this.$v.calculadora.$touch();
      if (this.$v.calculadora.$invalid) {
        return;
      }

      let plazo = 0;

      if (this.calculadora.mesesPlazo) plazo = this.calculadora.mesesPlazo;
      if (this.calculadora.diasPlazo) plazo = this.calculadora.diasPlazo;

      this.setAhorroCalculado({
        interes: this.interes,
        plazo: plazo,
        cuotaAhorro: this.calculadora.cuotaMensual,
        monto: this.calculadora.montoInicial,
        tipoAhorro: this.ahorroSelecionado,
      });
      this.mostrarParametros = false;
    },
    async onImprimirClick() {
      await this.$htmlToPaper("printMe");
    },
    onCalcularNuevamenteClick() {
      this.mostrarCalcularAhorro = false;
      this.calculadora.tipoAhorro = null;
      this.mostrarParametros = true;
      this.calculadoraValidar.montoInicial = false;
      this.calculadoraValidar.mesesPlazo = false;
      this.calculadoraValidar.diasPlazo = false;
      this.calculadoraValidar.cuotaMensual = false;
      this.calculadoraValidar.tasaInteres = false; //La uso solo par ocultar y mostrat interes, no hay validacion

      this.calculadora.montoInicial = null;
      this.calculadora.mesesPlazo = null;
      this.calculadora.diasPlazo = null;
      this.calculadora.cuotaMensual = null;
      this.resetAhorroCalculado();
    },
    ...mapActions(["setPrestamoCalculado", "setAhorroCalculado", "resetAhorroCalculado"]),
  },
  computed: {
    ...mapGetters({
      ahorroCalculado: "getAhorroCalculado",
      parametrosCoacAhorros: "getParametrosCoacAhorros",
      isLoading: "getIsLoading",
    }),
    interes() {
      let interes = 0.0;
      if (this.ahorroSelecionado) {
        if (this.ahorroSelecionado.ahorroProgramado.length > 0) {
          this.ahorroSelecionado.ahorroProgramado.forEach((element) => {
            if (this.calculadora.montoInicial >= element.montoInicial) {
              interes = element.interes;
            }
          });
        }
        if (this.ahorroSelecionado.ahorroPlazoFijo.length > 0) {
          this.ahorroSelecionado.ahorroPlazoFijo.forEach((element) => {
            if (
              this.calculadora.montoInicial <= element.cantidadMaximaAhorro &&
              this.calculadora.montoInicial >= element.cantidadMinimaAhorro
            ) {
              interes = element.interes;
            } else if (
              element.cantidadMaximaAhorro == 0 &&
              this.calculadora.montoInicial >= element.cantidadMinimaAhorro
            ) {
              interes = element.interes;
            }
          });
        }

        if (this.ahorroSelecionado.depositoPlazoFijo.length > 0) {
          this.ahorroSelecionado.depositoPlazoFijo.forEach((element) => {
            if (
              this.calculadora.diasPlazo >= element.plazo_rango_base &&
              this.calculadora.diasPlazo <= element.plazo_rango_limite
            ) {
              interes = element.interes;
            }
          });
        }
      }
      return interes;
    },
    montoInicialError() {
      const errors = [];
      if (!this.$v.calculadora.montoInicial.$dirty) return errors;
      !this.$v.calculadora.montoInicial.required &&
        errors.push("Ingrese el monto de la cuota inicial");
      !this.$v.calculadora.montoInicial.decimal &&
        errors.push("Ingrese un monto  de cuota inicial válido");
      return errors;
    },
    mesesPlazoError() {
      const errors = [];
      if (!this.$v.calculadora.mesesPlazo.$dirty) return errors;
      !this.$v.calculadora.mesesPlazo.required && errors.push("Ingrese el plazo en meses");
      !this.$v.calculadora.mesesPlazo.numeric && errors.push("Ingrese el número meses plazo ");
      return errors;
    },
    diasPlazoError() {
      const errors = [];
      if (!this.$v.calculadora.diasPlazo.$dirty) return errors;
      !this.$v.calculadora.diasPlazo.required && errors.push("Ingrese el plazo en días");
      !this.$v.calculadora.diasPlazo.numeric && errors.push("Ingrese el número días plazo ");
      return errors;
    },
    cuotaMensualError() {
      const errors = [];
      if (!this.$v.calculadora.cuotaMensual.$dirty) return errors;
      !this.$v.calculadora.cuotaMensual.required && errors.push("Ingrese la cuota mensual");
      !this.$v.calculadora.cuotaMensual.numeric &&
        errors.push("Ingrese valor de la cuota mensual ");
      return errors;
    },
    tipoAhorroError() {
      const errors = [];
      if (!this.$v.calculadora.tipoAhorro.$dirty) return errors;
      !this.$v.calculadora.tipoAhorro.required && errors.push("Seleccione un tipo de ahorro");

      return errors;
    },
  },
  validations: {
    calculadora: {
      montoInicial: {
        required: requiredIf(function () {
          return this.calculadoraValidar.montoInicial;
        }),
        decimal,
      },
      mesesPlazo: {
        required: requiredIf(function () {
          return this.calculadoraValidar.mesesPlazo;
        }),
        numeric,
      },
      diasPlazo: {
        required: requiredIf(function () {
          return this.calculadoraValidar.diasPlazo;
        }),
        numeric,
      },
      cuotaMensual: {
        required: requiredIf(function () {
          return this.calculadoraValidar.cuotaMensual;
        }),
        numeric,
      },
      tipoAhorro: {
        required,
      },
    },
  },
  mounted: function () {
    this.resetAhorroCalculado();
  },
};
</script>
